declare global {
	interface Window {
		CLIENT_ENV: Record<string, EnvVarValue>;
	}
}

type EnvVarValue = string | boolean | number | undefined | Record<string, unknown> | EnvVarValue[];
const DISABLE_THIRD_PARTY_QS_NAME = 'disable3rdParties';

let cachedConfig: Record<string, EnvVarValue> | undefined;

const parseConfig = (config: Record<string, EnvVarValue>): Record<string, EnvVarValue> =>
	Object.keys(config).reduce((acc, key) => {
		let value: EnvVarValue = process.env[key];

		// convert boolean strings to boolean types
		value = value === 'true' ? true : value;
		value = value === 'false' ? false : value;

		// convert JSON values
		if (typeof value === 'string' && value.startsWith('{') && value.endsWith('}')) {
			try {
				value = JSON.parse(value);
			} catch (e) {
				// console.log(e);
			}
		}

		return {
			...acc,
			[key.replace(/^NX_/, '')]: value,
		};
	}, {});

const getConfig = (): Record<string, EnvVarValue> => {
	if (cachedConfig) {
		return cachedConfig;
	}

	if (typeof window === 'undefined') {
		const envVars = parseConfig(process.env);
		cachedConfig = envVars;
	} else {
		cachedConfig = window.CLIENT_ENV;
	}

	return cachedConfig || {};
};

const is3rdPartyDisabled = (key: string): boolean => {
	const config = getConfig();
	const configKey = Object.keys(config).find((configKey: string) => {
		return (
			configKey.includes('DISABLE_') && configKey.toLowerCase().includes(key.replace('-', '_'))
		);
	});

	if (configKey && config[configKey]) {
		return true;
	}

	if (
		config['FSHR_PUBLIC_ALLOW_THIRD_PARTY_QS_CONTROL'] &&
		typeof window !== 'undefined' &&
		window.location?.search
	) {
		const searchParams = new URLSearchParams(window.location?.search);
		const disabled3rdParties = searchParams.get(DISABLE_THIRD_PARTY_QS_NAME);
		if (disabled3rdParties) {
			return disabled3rdParties.includes('all') || disabled3rdParties.includes(key);
		}
	}
	return false;
};

export { getConfig, parseConfig, is3rdPartyDisabled };
export type { EnvVarValue };
